"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detectFlexGapSupported = exports.isStyleSupport = exports.canUseDocElement = void 0;

var _canUseDom = _interopRequireDefault(require("rc-util/lib/Dom/canUseDom"));

var canUseDocElement = function canUseDocElement() {
  return (0, _canUseDom["default"])() && window.document.documentElement;
};

exports.canUseDocElement = canUseDocElement;

var isStyleSupport = function isStyleSupport(styleName) {
  if (canUseDocElement()) {
    var styleNameList = Array.isArray(styleName) ? styleName : [styleName];
    var documentElement = window.document.documentElement;
    return styleNameList.some(function (name) {
      return name in documentElement.style;
    });
  }

  return false;
};

exports.isStyleSupport = isStyleSupport;

var detectFlexGapSupported = function detectFlexGapSupported() {
  return true;
};

exports.detectFlexGapSupported = detectFlexGapSupported;